import { Link, useLocation } from "react-router-dom";
import { timestampToNumericPersianDate } from "../../utils/function.utils";
import OrderCardImage from "./OrderCardImage";

const OrderCard = ({ data, tabStatus, orderName }) => {
  const location = useLocation();
  const { hash, pathname, search } = location;

  return (
    <div
      className={
        "py-6 px-4 flex flex-col gap-3 shadow-custom1 rounded-8 h-fit mx-4 my-4"
      }
    >
      <div className={"flex items-center justify-between"}>
        <div className={"flex items-center gap-1"}>
          <span
            className={`inline-block w-[12px] h-[12px] rounded-full`}
            style={{ backgroundColor: tabStatus?.color }}
          />
          <span
            className={`font-medium text-14`}
            style={{ color: tabStatus?.color }}
          >
            {tabStatus?.name}
          </span>
        </div>
        <Link
          to={pathname + "/" + data?.id}
          className={
            "flex items-center gap-1 text-[#1E67BF] font-medium text-14"
          }
        >
          <span>جزئیات سفارش</span>
          <i className={"i-arrow-left-1 text-[18px]"} />
        </Link>
      </div>
      <p className={"text-[#454545] font-medium text-14"}>مشخصات سفارش : </p>
      <div
        className={
          "flex size830:flex-row flex-col size830:items-center size830:gap-9 gap-3"
        }
      >
        <div>
          <span className={"text-[#454545] text-14"}>نام وسیله نقلیه : </span>
          <span className={"text-[#0F0F0F] text-14 font-medium"}>
            {data?.vehicle_tip?.title_brand} {data?.vehicle_tip?.title_model}
          </span>
        </div>
        <div>
          <span className={"text-[#454545] text-14"}>تاریخ : </span>
          <span className={"text-[#0F0F0F] text-14 font-medium"}>
            {timestampToNumericPersianDate(data?.created_at * 1000)}
          </span>
        </div>
        <div>
          <span className={"text-[#454545] text-14"}>کد سفارش : </span>
          <span className={"text-[#0F0F0F] text-14 font-medium"}>
            {data?.code}
          </span>
        </div>
        <div>
          <span className={"text-[#454545] text-14"}>مبلغ : </span>
          <span className={"text-[#0F0F0F] text-14 font-medium"}>
            {Number(data?.price_total).toLocaleString()} تومان
          </span>
        </div>
      </div>
      <div className={"w-full h-px bg-[#BBBBBB]"} />
      <p>خلاصه سفارش :</p>
      <div
        className={
          "flex size830:flex-row flex-col size830:items-center size830:gap-9 gap-3"
        }
      >
        <div>
          <span className={"text-[#454545] text-14"}>تاریخ انجام : </span>
          <span className={"text-[#0F0F0F] text-14 font-medium"}>
            {/*{persianDate(data?.reserveTime?.start_timestamp, "dddd")}*/}
          </span>{" "}
          <span className={"text-[#0F0F0F] text-14 font-medium"}>
            {/*{persianDate(data?.reservation_time_slice_id?.day, "L")}*/}
            {timestampToNumericPersianDate(
              data?.reservation_time_slice_id?.day * 1000,
            )}
          </span>
        </div>
        <div>
          <span className={"text-[#454545] text-14"}>زمان انجام : </span>
          <span className={"text-[#0F0F0F] text-14 font-medium"}>
            {data?.reservation_time_slice_id?.start_time}
          </span>{" "}
          <span>تا</span>{" "}
          <span className={"text-[#0F0F0F] text-14 font-medium"}>
            {data?.reservation_time_slice_id?.end_time}
          </span>
        </div>
        <div>
          {orderName === "periodic_service" && (
            <>
              <span className={"text-[#454545] text-14"}>نوع سرویس : </span>
              <span className={"text-[#0F0F0F] text-14 font-medium"}>
                سرویس دوره ای
              </span>
            </>
          )}
          {orderName === "master" && (
            <>
              <span className={"text-[#454545] text-14"}>نوع کارشناسی : </span>
              <span className={"text-[#0F0F0F] text-14 font-medium"}>
                {data?.order_items?.length > 0
                  ? data?.order_items[0]?.package?.title
                  : ""}
              </span>
            </>
          )}
          {orderName === "battery" && (
            <>
              <span className={"text-[#454545] text-14"}>نوع باتری : </span>
              <span className={"text-[#0F0F0F] text-14 font-medium"}>
                {/*{data?.orderItems[0]?.product?.product_brand_name} -{" "}*/}
                {/*{data?.orderItems[0]?.product?.name}*/}
              </span>
            </>
          )}
        </div>
      </div>
      {orderName !== "master" && (
        <div
          className={
            "flex items-center gap-4 size830:max-w-full max-w-[300px] overflow-x-scroll pb-4"
          }
        >
          {data?.order_items?.length > 0 &&
            data?.order_items.map((item, index) => (
              <OrderCardImage item={item} />
            ))}
        </div>
      )}
    </div>
  );
};

export default OrderCard;
